import { useMutation, useSuspenseQuery } from '@tanstack/react-query'

import { useMe } from '@shared/providers/src/MeProvider'
import { setQueryData } from '@shared/providers/src/QueryClientProvider'
import API from '@shared/services/src/API'
import { QK } from '@shared/utils'

export default function useSchedulingEligibilities() {
  const me = useMe()

  const { data } = useSuspenseQuery({
    queryKey: QK.patients.id(me.id).schedulingEligibilities.list(),
    queryFn: () => API.patients.id(me.id).schedulingEligibilities.list(),
  })

  return data
}

export function useRefetchSchedulingEligibilities() {
  const me = useMe()

  return useMutation({
    mutationFn: () => API.patients.id(me.id).schedulingEligibilities.list(),
    onSuccess: (data) => setQueryData(QK.patients.id(me.id).schedulingEligibilities.list(), data),
  })
}
